/*  ========================================================================
    # Sections - Quotes - Index
    ========================================================================  */

import React from 'react';
import { createRoot, type Container } from 'react-dom/client';
import Quotes from './Quotes';

export type QuotesProps = {
  headline: string;
  entries: Array<{
    content: string;
    logo: {
      alt: string;
      sizes: {
        'thumbnail': string;
        'thumbnail-width': number;
        'thumbnail-height': number;
        'medium': string;
        'medium-width': number;
        'medium-height': number;
        'medium_large': string;
        'medium_large-width': number;
        'medium_large-height': number;
        'large': string;
        'large-width': number;
        'large-height': number;
        '1536x1536': string;
        '1536x1536-width': number;
        '1536x1536-height': number;
        '2048x2048': string;
        '2048x2048-width': number;
        '2048x2048-height': number;
        'placeholder': string;
        'placeholder-width': number;
        'placeholder-height': number;
      };
    };
    name: string;
    position: string;
  }>;
};

const containers = document.querySelectorAll('div[data-react-app="quotes"]');

for (let i = 0; i < containers.length; i++) {
  const containerGuid = (containers[i]?.attributes as any)['data-guid']?.value;
  const props = (window as any).reactProps[containerGuid] as QuotesProps;

  createRoot(containers[i] as Container).render(<Quotes {...props} />);
}
